import React, { useEffect } from "react";
import Register from "./Pages/Register";
import { ToastContainer } from "react-toastify";
import { Routes, Route, useLocation } from "react-router-dom";
import Login from "./Pages/Login";
import NotFound from "./Pages/Notfound";
import ResetPassword from "./Pages/ResetPassword";
import { SWRConfig } from "swr";
import { swrConfig } from "./Api/swrConfig";
import { routes, studentRoutes } from "./Components/Common/RenderRoutes";
import { useAuth } from "./Context/AuthContext";
import { publicRoutes } from "./Components/Common/PublicRoutes";
import { Loader } from "./Components/Common/Loader";
import SEOController from "../src/Components/Common/SEO";
import TawkMessenger from "./Components/Common/ChatWidget";
import { dashboardUrls, one2OneTutoring, publicUrls } from "./Api/Auth/AppUrls";
import { findRouteBySlug } from "./utils/findRouteBySlug";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top on route change
  }, [location]);

  return null; // This component doesn't need to render anything
}
function App() {
  // Simulated authentication function
  const { userData, loading, categoryData, categoryLoading } = useAuth();

  const userRoutes =
    userData?.roleId === 2
      ? studentRoutes
      : userData?.roleId === 6
      ? routes.filter(
          (item) =>
            ![dashboardUrls.admin, one2OneTutoring.purchase].includes(
              item.route
            )
        )
      : routes;
  const location = useLocation();

  // Create a map of route URLs to their visibility status
  const getRouteVisibility = () => {
    if (!categoryData) return new Set();

    const visibleRoutes = new Set();

    categoryData.forEach((category) => {
      if (category.courses) {
        category.courses.forEach((course) => {
          if (course.visibility !== false && course.slug) {
            // Map slugs to their corresponding route URLs
            // You'll need to determine which publicUrls correspond to which slugs
            const routeUrl = findRouteBySlug(course.slug);
            if (routeUrl) {
              visibleRoutes.add(routeUrl);
            }
          }
        });
      }
    });

    return visibleRoutes;
  };

  const visibleCourseRoutes = getRouteVisibility();

  // Always show these non-course routes
  const alwaysVisibleRoutes = [
    publicUrls.Home,
    publicUrls.About,
    publicUrls.Contact,
    publicUrls.NewsArchive,
    publicUrls.BlogsArchive,
    publicUrls.Blog,
    publicUrls.LiveOnlineClass,
    publicUrls.Tutorial,
    publicUrls.SelfStudy,
    publicUrls.News,
    publicUrls.CivilCourses,
    publicUrls.MechanicalCourses,
    publicUrls.staticPage,
  ];

  // Filter routes that should be shown
  const filteredRoutes = publicRoutes.filter((item) => {
    // Always show non-course routes
    if (alwaysVisibleRoutes.includes(item.route)) {
      return true;
    }

    // For course routes, check visibility
    return visibleCourseRoutes.has(item.route);
  });

  //restrict from going to dev tools
  useEffect(() => {
    // Disable right-click context menu
    const disableRightClick = (event) => {
      event.preventDefault();
    };
    window.addEventListener("contextmenu", disableRightClick);

    // Detect F12 or other keys
    const detectDevTools = (event) => {
      if (event.key === "F12") {
        event.preventDefault();
      }
      if (event.ctrlKey && event.shiftKey && event.key === "I") {
        event.preventDefault();
      }
      if (event.ctrlKey && event.shiftKey && event.key === "C") {
        event.preventDefault();
      }
      if (event.ctrlKey && event.shiftKey && event.key === "J") {
        event.preventDefault();
      }
      if (event.ctrlKey && event.key === "U") {
        event.preventDefault();
      }
      // if (event.key === 'F12' || (event.ctrlKey && event.shiftKey && event.key === 'I')) {
      //   alert('Developer tools are not allowed!')
      //   window.location.href = 'about:blank' // Redirects to a blank page
      // }
    };
    window.addEventListener("keydown", detectDevTools);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("contextmenu", disableRightClick);
      window.removeEventListener("keydown", detectDevTools);
    };
  }, []);

  return (
    <SWRConfig value={swrConfig}>
      <ScrollToTop />
      <SEOController />
      <ToastContainer />
      <TawkMessenger />
      {loading || categoryLoading ? (
        <div className="w-screen h-screen flex items-center justify-center">
          <Loader />
        </div>
      ) : (
        <Routes>
          {filteredRoutes.map((item, index) => (
            <Route key={index} path={item.route} element={item.element} />
          ))}
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected Routes */}
          {userRoutes.map((item, index) => (
            <Route key={index} path={item.route} element={item.element} />
          ))}
          {/* 404 Page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
    </SWRConfig>
  );
}

export default App;
